module.exports = __webpack_public_path__ + "static/media/doge.7a96c7d6.ico";